"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedConversationStyleMap = exports.containerNodeTypeMap = void 0;
const enums_1 = require("./enums");
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
exports.containerNodeTypeMap = {
    [enums_1.NodeType.COMMUNITY]: enums_1.NodeType.COMMUNITY,
    [enums_1.NodeType.CATEGORY]: enums_1.NodeType.CATEGORY,
    [enums_1.NodeType.GROUPHUB]: enums_1.NodeType.GROUPHUB
};
exports.allowedConversationStyleMap = {
    'FORUM-board': graphql_schema_types_1.ConversationStyle.Forum,
    'BLOG-board': graphql_schema_types_1.ConversationStyle.Blog,
    'TKB-board': graphql_schema_types_1.ConversationStyle.Tkb,
    'IDEA-board': graphql_schema_types_1.ConversationStyle.Idea,
    'OCCASION-board': graphql_schema_types_1.ConversationStyle.Occasion
};
//# sourceMappingURL=types.js.map